import React, { Fragment } from 'react'
import Topbanner from '../../Components/Main/TopBanner'
import BooksList from '../../Components/Books/BooksList'
const Books = () => {
    return (
        <Fragment>
            <Topbanner title={"Books"} />
            <BooksList />
        </Fragment>
    )
}

export default Books